import vConsole from 'vconsole';

/* eslint-disable */
let VConsole
if (process.env.NODE_ENV === 'development') {
  VConsole = new vConsole()
}

export default VConsole
